import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const reportsAPI = {
  // Dashboard Summary
  getDashboardSummary: async () => {
    const response = await axios.get(`${API_URL}/api/reports/dashboard`, {
      withCredentials: true
    });
    return response.data;
  },

  // Sales Report
  getSalesReport: async (period = 'daily', startDate = null, endDate = null) => {
    const params = new URLSearchParams({ period });
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const response = await axios.get(`${API_URL}/api/reports/sales?${params}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Orders Report
  getOrdersReport: async (startDate = null, endDate = null) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const response = await axios.get(`${API_URL}/api/reports/orders?${params}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Customers Report
  getCustomersReport: async (startDate = null, endDate = null) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const response = await axios.get(`${API_URL}/api/reports/customers?${params}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Inventory Report
  getInventoryReport: async () => {
    const response = await axios.get(`${API_URL}/api/reports/inventory`, {
      withCredentials: true
    });
    return response.data;
  },

  // Suppliers Report
  getSuppliersReport: async () => {
    const response = await axios.get(`${API_URL}/api/reports/suppliers`, {
      withCredentials: true
    });
    return response.data;
  },

  // Export Report
  exportReport: async (reportType, format = 'csv') => {
    const response = await axios.get(`${API_URL}/api/reports/export/${reportType}?format=${format}`, {
      withCredentials: true,
      responseType: 'blob'
    });
    return response.data;
  }
};

export default reportsAPI;
